/* eslint-disable react/no-array-index-key */

import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Grid from '@material-ui/core/Grid';
import RenderTextField from '../../../../utils/renderFields/RenderTextField';

/**
 * Formulaire permettant de mettre à jours les produit présent
 * dans la commande
 *
 * @param {Object} fields       The Fields object
 * @param {Number} commandIndex Index de la commande actuelle
 */
const RenderProducts = ({ fields, currentIndex }) => (
  <div>
    {fields.map((item, index) => (
      <div hidden={!(currentIndex === index)} key={index}>
        <Grid container spacing={2} key={index}>
          <Grid item md={12}>
            <Field
              name={`${item}.externalReference`}
              label="Référence du produit ( sku )"
              component={RenderTextField}
              displayErrorBeforeSubmit
              fullWidth
              type="text"
            />
          </Grid>
          <Grid item md={12}>
            <Field
              name={`${item}.ean13`}
              label="Code-barres (EAN 13)"
              component={RenderTextField}
              displayErrorBeforeSubmit
              fullWidth
              type="text"
            />
          </Grid>
          <Grid item md={12}>
            <Field
              name={`${item}.quantity`}
              label="Quantité"
              component={RenderTextField}
              displayErrorBeforeSubmit
              fullWidth
              type="text"
            />
          </Grid>
          <Grid item md={12}>
            <Field
              name={`${item}.description`}
              label="Description"
              component={RenderTextField}
              displayErrorBeforeSubmit
              fullWidth
              type="text"
            />
          </Grid>
        </Grid>
      </div>
    ))}
  </div>
);

RenderProducts.propTypes = {
  fields: PropTypes.object.isRequired,
  currentIndex: PropTypes.number.isRequired
};

export default RenderProducts;
